var map = {
	"./logo.png": 6949,
	"./obocos.png": 8151,
	"./platform/all.png": 8985,
	"./platform/axs.png": 6213,
	"./platform/ballpark.png": 7523,
	"./platform/mapper.png": 5724,
	"./platform/oss.png": 7537,
	"./platform/paciolan.png": 8902,
	"./platform/qrcode.png": 6078,
	"./platform/seatgeek.png": 3696,
	"./platform/tickets.png": 494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;